import { documentBundleActions } from 'src/redux/actions/constant';

const {
  SUCCESS_SEARCH_PATIENTS,
  FAILURE_SEARCH_PATIENTS,
  LOADING_SEARCH_PATIENTS,
  RESET_SEARCH_PATIENTS,
} = documentBundleActions;

const initialState = {
  response: null as any,
  loading: false,
};

export const searchPatientsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOADING_SEARCH_PATIENTS:
      return { ...state, loading: true };
    case SUCCESS_SEARCH_PATIENTS:
      return { ...state, loading: false, response: action.payload };
    case FAILURE_SEARCH_PATIENTS:
      return { ...state, loading: false, response: null };
    case RESET_SEARCH_PATIENTS:
      return initialState;
    default:
      return state;
  }
};
